<script>

import {
    Router,
    Link,
    Route,
    link,
    navigate
} from "svelte-routing";
import QRreader from "../components/qr_reader.svelte"
import Header from "../components/header.svelte"
import CardPanier from "../components/cardPanier.svelte"
import { isUserDbAdmin} from './stores.js';


export let db;
export let auth;

export let location;
location = location;

let text;
var user = auth.currentUser;
var is_Admin = false;
var nom_Admin;
var enCours = false;
var req = false;
var historique = false;

var montantPanier = 0;
var jouetsPanier = []
var articles = 0;

var listePaniers = [];
var reqPaniers = false
var modePaiement = ""

var info_color = "slategray"
var info_text = "Scan en cours"

var beep = new Audio('./bip.mp3')

var traitement = false

function isPresent(arr,el){
  arr.forEach(element => {
    if(el.montantPanier == element.montantPanier){
      return true
    }
  });
  return false
}


function getPaniers() {
    reqPaniers = false
    listePaniers = []
    db.collection("paniers").orderBy("montantPanier", "asc").get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            listePaniers.push(doc.data())
        });
        console.log(listePaniers)
        let singles = []
        listePaniers.forEach(panier => {
          
        if(isPresent(listePaniers,panier.listeJouets)){
          console.log(panier.montantPanier)
        }
      });
        reqPaniers = true
    });
}

getPaniers()


function isAlreadyScanned(jouetId){
 for(let i=0; i< jouetsPanier.length;i++){
   if(jouetsPanier[i].id == jouetId){
     return true
   }
}
  return false
}

function isAlreadyVendu(jouetId){
  db.collection("jouets").doc(jouetId).get().then((doc) => {
        if (doc.exists) {
            if (doc.data().vendu) {
              return true
          }
          else{
            return false
          }
        }
        else{
          info_color = "purple";
          info_text = "Cet article n'existe pas";
          setTimeout(() => {
            info_color = "slategray";
          info_text = "Scan en cours";
          enCours = false
          }, 3000)
        }
      }
)}


function scane(event) {
    if (!enCours) {
        enCours = true;
        text = event.detail.data
        if(isAlreadyScanned(text)){
          info_color = "orange";
          info_text = "Article déjà scanné";
          setTimeout(() => {
            info_color = "slategray";
          info_text = "Scan en cours";
          enCours = false
          }, 3000)
        }
        else{
          beep.play()
          document.querySelector('.layout').style.display = "flex";
        }
    }

}


function jincremente(a) {
    return firebase.firestore.FieldValue.increment(a);
}

function jdecremente(a) {
    return firebase.firestore.FieldValue.increment(-a);
}

function close() {
    enCours = false;
    document.querySelector('.layout').style.display = "none";
}

var showPanier = true;

function addJouetPanier() {
    req = false
    showPanier = false
    db.collection("jouets").doc(text).get().then((doc) => {
        if (doc.exists) {
            if (!doc.data().vendu) {
                var temp = doc.data()
                temp.id = doc.id
                montantPanier += doc.data().prix
                articles += 1;
                console.log(temp)
                jouetsPanier.push(temp)
                close()
                showPanier = true
                req = true;
                console.log("req apres ajout : ", req)
                console.log("Jouet dans le panier apres ajout : ", jouetsPanier)
                console.log("Montant dans le panier apres ajout : ", montantPanier)
            } else {
                close()
                req = true;
                showPanier = true;
                info_color = "red";
                info_text = "Article déjà vendu";
                setTimeout(() => {
                  info_color = "slategray";
                  info_text = "Scan en cours";
                  enCours = false
              }, 3000)
            }
        } else {
            // doc.data() will be undefined in this case
            close()
            showPanier = true
            req = true
            info_color = "purple";
            info_text = "Cet article n'existe pas";
            setTimeout(() => {
              info_color = "slategray";
              info_text = "Scan en cours";
              enCours = false
            }, 3000)
            console.log("No such document!");
        }
    }).catch((error) => {
        req = true
        console.log("Error getting document:", error);
    });

}

function suppJouet(jouet) {
    req = false;
    console.log('Jouet panier avant supression : ', jouetsPanier)
    jouetsPanier.splice(jouetsPanier.indexOf(jouet), 1)
    montantPanier -= jouet.prix;
    articles -= 1;
    setInterval(() => {
      req = true;
    },500);
    console.log('Jouet panier après supression : ', jouetsPanier)
}


function toggleMode(){
  if(!historique){
    historique = true;
    console.log("historque", historique)
    getPaniers()
  }else{
    historique = false;
    console.log("historque", historique)
  }
}

function mettreHistorique() {
    historique = true;
    console.log("historque", historique)
    getPaniers()
}

function enleverHistorique() {
    historique = false;
    console.log("historque", historique)
}

function goPanier() {
    navigate("/panier", {
        replace: false
    });
}

function goClients() {
    navigate("/clients", {
        replace: false
    });
}

function goListe() {
    navigate("/user", {
        replace: false
    });
}

function goJouets() {
    navigate("/jouets", {
        replace: false
    });
}

function goRdv() {
    navigate("/rdv", {
        replace: false
    });
}

function logout() {
    auth.signOut().then(() => {
        user = undefined;
        navigate("/", {
            replace: false
        });
        window.location.reload()
    }).catch((error) => {
        // An error happened.
    });
}

var storedUser;

const unsubscribe = isUserDbAdmin.subscribe(value => {
		storedUser = value;
	});

  if(storedUser.admin == true){
                is_Admin = true
                nom_Admin = storedUser.name
       }

auth.onAuthStateChanged(function(user) {
    if (user) {
        user = auth.currentUser

        if(!storedUser){
          console.log("n'a pas été determiné si admin")
          db.collection("admins").doc(user.uid).get().then((doc) => {
            
            if (doc.exists) {
                  isUserDbAdmin.set({admin:true,name:doc.data().Nom});
                  is_Admin = true
                  nom_Admin = doc.data().name
                  console.log(doc.data(),"is admin")
              } else {
                  isUserDbAdmin.set({admin:false})
                  console.log('not logged in')
                  window.location = "https://baj-leperreuw.web.app/";
              }
              console.log("storedUser", storedUser)
              if(storedUser.admin == true){
                is_Admin = true
                nom_Admin = storedUser.name
       }
          }).catch((error) => {
              console.log("Error getting document:", error);
          });;
        }
        
        


    } else {
        // No user is signed in.
        window.location = "https://baj-leperreuw.web.app/"; 
    }
});


function finaliser() {
    traitement = true
    if (jouetsPanier.length) {
      for(let i=0;i<jouetsPanier.length;i++){
        if(!jouetsPanier[i].vendu){
          jouetsPanier[i].vendu = true;
          db.collection("jouets").doc(jouetsPanier[i].id).update({
            vendu: true
        }).then(() => {
          db.collection("users").doc(jouetsPanier[i].owner_id).update({
            gain: jincremente(jouetsPanier[i].prix),
            nbVendus: jincremente(1)
        })
        }).catch((error) => {
          jouetsPanier[i].vendu = false
        });
        }
        
        
      }
      console.log(jouetsPanier)
      console.log(montantPanier)
      console.log(articles)
      console.log(nom_Admin)
      console.log(modePaiement)
        db.collection("paniers").add({
                listeJouets: jouetsPanier,
                montantPanier: montantPanier,
                nbArticles: articles,
                vendeur: nom_Admin,
                modePaiement: modePaiement
            }).then((docRef) => {
                jouetsPanier = []
                enCours = false;
                req = false;
                montantPanier = 0;
                articles = 0;
                modePaiement = "";
                console.log("- - - - - - - - - -")
                console.log('reinit effectuer')
                console.log("Jouet dans le panier : ", jouetsPanier)
                console.log("En cours : ", enCours)
                console.log("Requete : ", req)
                console.log("Montant panier : ", montantPanier)
                console.log("- - - - - - - - - -")
                maPopup.style.display = "none";
                traitement = false
            })
            .catch((error) => {
                console.error("Error adding document: ", error);
                maPopup.style.display = "none";
                traitement = false
                alert("Erreur lors de la création du panier")
            });
    } else {
        alert('Panier vide')
    }

}


var maPopup;

function processFinalPanier(){
  if(modePaiement == "cb" && montantPanier !=0){
    montantPanier += 0.5
  }
  maPopup.style.display = "flex";
}

function processAnnulationPanier(){
  if(modePaiement == "cb" && montantPanier !=0){
    montantPanier -= 0.5
  }
  maPopup.style.display = "none";
}



</script>

<main>
    <div class="cache"></div>
    <Header>
      <div on:click={logout} class="elm">Déconnexion</div>
      <div class="elm" on:click={goListe}>Ma liste 📃</div>
      <div class="elm" on:click={goRdv}>RDV ⏰</div>
      {#if is_Admin}
      <div class="elm" on:click={goJouets}>Articles 🧸</div>
      <div class="elm" on:click={goClients}>Vendeurs 👱‍♂️</div>
      <div class="elm" on:click={goPanier}>Panier 🛒</div>
        {/if}
      </Header>


      
      <div class="layout">
        <button class="addPanier" on:click={addJouetPanier}>Ajouter au panier</button>
        <button class="close" on:click={close}>Annuler</button>
      </div>



        <div class="mes-btns">
          <h2 style="color:white;">Mode caisse</h2>
          <label class="switch">
            <input type="checkbox" on:change={toggleMode} >
            <span class="slider round"></span>
          </label>
          <h2 style="color:white;">Mode historique</h2>
        </div>

        {#if !historique}
        <div class="medium-contain">
          <div class="left-contain">
            <div class="qr-reader" style="margin-top:30px;border-radius:30px;border: 10px {info_color} solid;">
              <QRreader on:scan={scane} ></QRreader>
            </div>
            <div style="font-size: 2em;color:{info_color}">{info_text}</div>
          </div>
          <div class="right-contain">
            <h1 style="color:white;">{articles} article{articles < 2 ? "" : "s"} / Montant : <b>{montantPanier.toFixed(2)}€</b> </h1>
              {#if req}
              {#if showPanier}
              {#each jouetsPanier as jouet}
              <div class="jouet">
                  <p style="margin:7px;">{jouet.prix}€</p>
                  <p style="margin:7px;">{jouet.name}</p>
                  <div style="cursor:pointer" on:click={()=>{suppJouet(jouet)}}>🗑️</div>
              </div>
              {/each}
              {/if}
              {/if}
              {#if articles}
              <select name="paiement" id="paiment" bind:value={modePaiement}>
                <option value="">--Mode paiement--</option>
                <option value="cb" >Carte bancaire</option>
                <option value="Especes">Espèces</option>
                <option value="Cheque">Cheque</option>
              </select>
              <button class="addPanier" on:click={()=>{if(modePaiement != ""){processFinalPanier()}else{alert("Indiquer mode de paiement")}}}>Finaliser</button>
              {/if}
          </div>

        </div>


    <!-- - -  - - - - - - - - STOP <button on:click={()=>beep.play()}>Bip</button> - - - - - - - - - - - - -->
    {:else}
    {#if reqPaniers}
    {#each listePaniers as panier }
      <CardPanier {panier}></CardPanier>
    {/each}
    {/if}
    {/if}


    <div class="blur" bind:this={maPopup}>
      <div class="popupValidation">
        {#if !traitement}
        <h1 style="color: teal;">Validation</h1>
        <div class="info">
          <h3>Montant Total à payer : {montantPanier.toFixed(2)}€ {modePaiement == "cb" ? " (+0.50€ car paiement carte bancaire)" : ""}</h3>
          <button class="addPanier" on:click={finaliser}>Finaliser le panier</button>
          <button class="close" on:click={processAnnulationPanier}>Annuler</button>
        </div>
        {:else}
        <h1 style="color: teal;">Traitement</h1>
        {/if}
        
        
        </div>
      </div>  </main>
    


<style>
    main{
        display: flex;
        width: 100vw;
        min-height: 100vh;
        flex-direction: column;
        align-items: center;
        background-color: #262626;
    }
  .elm{ 
        color: white;
        margin-right: 20px;
        cursor: pointer;
        font-weight: 700;
    }

    .elm:hover{
        color: #507DBC ;
        text-decoration: none;
    }
    .cache{
      width: 100vw;
      min-height: 15vh;
    }
    .layout{
        position: fixed;
        width: 100vw;
        height: 100vh;
        background-color: rgba(50,50,50,0.6);
        display: none;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-left: 20vw;
    }
    .addPanier{
      user-select: none;
        cursor: pointer;
        width: fit-content;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 1.6rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        animation: glow 3s ease-in infinite;
        box-shadow: 0px 0px 30px -10px #4db95f;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        text-align: center;
    }
    .close{
      user-select: none;
        cursor: pointer;
        width: fi;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 1.3rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        animation: glow2 3s ease-in infinite;
        box-shadow: 0px 0px 20px -5px #8b2825;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif; 
        font-weight: 400;
        text-align: center;
    }
    @keyframes glow {
  0% {
    background: #57d16b;
  }
  25% {
    background: #6fd681;
  }
  100% {
    background: #57d16b;
  }
}
@keyframes glow2 {
  0% {
    background: #b12924;
  }
  25% {
    background: #b84844;
  }
  100% {
    background: #b12924;
  }
}
    button{border: none;}

    .jouet{
        color: white;
        font-size: 1.5rem;
        display: flex;
        border-top: 1px solid ghostwhite;
        padding-top: 10px;
        align-items: center;
        justify-content: space-evenly;
        margin: 10px;
        width: 80%;
    }


    .medium-contain{
      display: flex;
      width: 100vw;
      flex-direction: row;
    }

    .left-contain{
      width: 60%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .info{
      display:flex;
      flex-direction: column;
      align-items: center;
    }

    .right-contain{
      display: flex;
      flex-direction: column;
      align-items: center;
      border-left: 2px solid white;
      min-height: 70vh;
      margin-top: 5vh;
      margin-bottom: 5vh;
      width: 40%;
    }


    .mes-btns{
      display: flex;
      align-items: center;
    }

    /*Slider*/

    .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin:12px
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

    /*end slider*/

    .blur{
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba(10,10,10,0.89);
      display: none;
      align-items: center;
      justify-content: center;
    }

    .popupValidation{
      background-color: white;
      border-radius: 20px;
      padding: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

</style>